module.exports = __webpack_public_path__ + "img/databases.6f9e69d9.svg";